import { memo } from "react";
import { CarouselWoList } from "../models/ResponseModels/CarouselResponse";

interface CarouselSlideProps {
  item: CarouselWoList;
  isActive: boolean;
  isVisible: boolean;
  onSlideClick: (uuid: string, imageUrl: string) => void;
  getImageUrl: (item: CarouselWoList) => string;
  getImageStyle: (isActive: boolean) => { filter: string; transition: string };
}

const CarouselSlide = memo(
  ({
    item,
    isActive,
    isVisible,
    onSlideClick,
    getImageUrl,
    getImageStyle,
  }: CarouselSlideProps) => {
    const handleClick = () => {
      if (item.images && item.images.length > 0) {
        onSlideClick(item.workorderId, item.images[0].imageUrl);
      }
    };

    return (
      <div
        className={`h-full w-[180%] ml-[-35%] ${
          isVisible ? "flex" : "hidden"
        } items-center`}
      >
        <div
          className="relative w-full aspect-w-16 aspect-h-9 h-[370px] text-white"
          onClick={handleClick}
        >
          <img
            src={getImageUrl(item)}
            className="absolute top-0 left-0 h-full w-full rounded-md object-cover"
            style={getImageStyle(isActive)}
            alt={item.title}
          />

          <div
            className="absolute bottom-0 left-0 right-0 p-6 rounded-md"
            style={{
              background:
                "linear-gradient(0deg, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.5) 80%, rgba(0,0,0,0.0) 100%)",
            }}
          >
            <h3 className="m-0 font-skyBold text-lg">{item.title}</h3>
            {item.description && (
              <p className="m-0">{item.description.slice(0, 160)}...</p>
            )}
          </div>
        </div>
      </div>
    );
  },
);

CarouselSlide.displayName = "CarouselSlide";

export default CarouselSlide;
